import { type Locale } from "./translations";

export const localePath = (path: string, locale: Locale): string => {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  if (locale === "no") return cleanPath;
  return `/${locale}${cleanPath}`;
};

export const localeAnchor = (id: string, locale: Locale): string => {
  if (locale === "no") return `/#${id}`;
  return `/${locale}/#${id}`;
};
